import React, { useMemo, useState } from "react";
import "../styles/SignInVerfication.css";
import userController from "../controllers/userController";
import { EncryptStorage } from "encrypt-storage";
import { toast } from "react-toastify";
import QrModal from "../components/QrModal";
import CloseIcon from "../icons/SignInIcon/closeIcon";
import TrachRedIcon from "../icons/SignInIcon/TrachIcon";
import ResetIcon from "../icons/SignInIcon/ResetIcon";
import CancelIcon from "../icons/SignInIcon/CancelIcon";
import { useNavigate } from "react-router-dom";
import Utils from "../utils/Utils";
import companyController from "../controllers/companyController";
import { userService } from "../services/userService";
function SignInVerification({
  rememberpass,
  rememberupi,
  upivalue,
  jwt,
  username,
  password,
}) {
  // const encryptStorage1 = new EncryptStorage("secret-key", {
  //   prefix: "@instance1",
  // });
  const encryptStorage2 = new EncryptStorage("secret-key1", {
    prefix: "@instance2",
  });
  const encryptStorage3 = new EncryptStorage("secret-key3", {
    prefix: "@instance3",
  });
  const encryptStorage4 = new EncryptStorage("secret-key4", {
    prefix: "@instance4",
  });
  const encryptStorage5 = new EncryptStorage("secret-key5", {
    prefix: "@instance5",
  });
  const parsed = Utils.parseJwt(jwt);
  // encryptStorage3.setItem("user-azalea", Object.keys(parsed.userDetails)[0]);
  const navigate = useNavigate();
  const [openMfaPopup, setOpenMfaPopup] = useState(false);
  const [code, setCode] = useState("");
  const [resetText, setResetText] = useState("");
  const [openQrPopup, setOpenQrPopup] = useState(false);
  const [qrBase64, setQrBase64] = useState(null);

  const encryptStorage1 = useMemo(
    () => new EncryptStorage("secret-key", { prefix: "@instance1" }),
    [],
  );

  const canReset = resetText.trim() === "RESET MFA";

  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");
    setCode(digitsOnly);
  };

  const closeResetPopup = () => {
    setOpenMfaPopup(false);
    setResetText("");
  };

  const hardRedirectHome = () => {
    setOpenMfaPopup(false);
    setOpenQrPopup(false);
    setQrBase64(null);
    setCode("");
    setResetText("");
    setTimeout(() => {
      // window.location.href = "/";
    }, 800);
  };

  const handleResetMfa = async () => {
    try {
      const resetMfaDTO = { upi: upivalue, username };
      const res = await userController.ResetMfa(resetMfaDTO, jwt);

      if (!Utils.isSuccessResponse(res)) {
        toast.error(res?.data?.message || "Reset MFA failed");
        return;
      }

      const enrollmultiA = { email: username, upi: upivalue };
      const enrollMfaRes = await userController.enrollMfa({
        mfaDTO: enrollmultiA,
        jwt,
      });

      if (!Utils.isSuccessResponse(enrollMfaRes)) {
        toast.error(enrollMfaRes?.data?.message || "Enroll MFA failed");
        return;
      }

      const base64 = enrollMfaRes?.data?.qrCodeBase64;

      if (base64) {
        if (rememberupi) encryptStorage1.setItem("upi", upivalue);
        toast.success(enrollMfaRes?.data?.message || "MFA enrolled");
        setQrBase64(base64);
        setOpenMfaPopup(false);
        setResetText("");
        setOpenQrPopup(true);
        return;
      }

      toast.error(enrollMfaRes?.data?.message || "Unexpected response");
    } catch (err) {
      const msg =
        err?.response?.data?.message || err?.message || "Reset MFA failed";
      toast.error(msg);
    }
  };

  const handleSignin = async () => {
    // const dataToSave = [];
    try {
      const mfaDTO = { code, upi: upivalue };
      const mfaRes = await userController.verifyMFA({ mfaDTO, jwt });
      const msg = String(mfaRes?.data?.message || "");

      if (!mfaRes?.data?.codeValid) {
        toast.error(msg || "Invalid code");

        return;
      }

      const dataToSave = {
        username: rememberpass ? username : null,
        password: rememberpass ? password : null,
        rememberpass: rememberpass,
      };
      const dataToSaved = {
        upi: rememberupi ? upivalue : null,
        rememberupi: rememberupi,
      };
      if (rememberupi) encryptStorage5.setItem("user-upi", dataToSaved);
      else if (!rememberupi) encryptStorage5.removeItem("user-upi");
      if (rememberpass) encryptStorage2.setItem("user-data", dataToSave);
      else if (!rememberpass) encryptStorage2.removeItem("user-data");
      encryptStorage1.setItem("user-azalea", jwt);
      const parsedJwt = Utils.parseJwt(jwt);
      const userId = Utils.getUserIdFromJwt(parsedJwt);
      // if (!userId) {
      //   toast.error("Missing userId in token");
      //   return;
      // }
      if (!userId) return;

      const res = await companyController.userPrimaryCompanies({
        Authorization: jwt,
        userId,
      });

      const list = res?.data;

      // if (list.length > 0) {
      const primary = list[0];

      encryptStorage3.setItem("user-azalea", primary.companyID);

      encryptStorage4.setItem("user-azalea", primary.businessProfileID);
      // }

      if (Utils.isSuccessResponse(mfaRes)) {
        toast.success(msg || "Verified");
      }
      navigate("/user-management");
    } catch (error) {
      toast.error("Verification failed");
    }
  };
  return (
    <>
      {openQrPopup && (
        <QrModal
          open={openQrPopup}
          qrBase64={qrBase64}
          onClose={() => {
            setOpenQrPopup(false);
          }}
        />
      )}

      {!openQrPopup && (
        <div className="signin-verification-main-container">
          <div className="signin-verification-title">Verification Required</div>

          <div className="signin-verification-text">
            <div className="signin-verification-text-note">
              Your account is protected with <br />
              <strong>Multi-factor authentication (MFA).</strong>
              <br /> <br />
              To finish signing in, <br />
              <strong>enter the code from your MFA device below.</strong>
            </div>
          </div>

          <div className="verification-code-container">
            <div className="verification-code-title">
              MFA code<div className="required">*</div>
            </div>

            <div className="verification-code-input-container">
              <input
                className="verification-code-input"
                type="text"
                inputMode="numeric"
                value={code}
                onChange={handleChange}
              />
            </div>

            <div className="mfa-reseting">
              <div className="reset-mfa" onClick={() => setOpenMfaPopup(true)}>
                Reset MFA
              </div>
            </div>

            {openMfaPopup && (
              <div className="mfa-popup-overlay">
                <div className="mfa-popup">
                  <div className="close-icon" onClick={closeResetPopup}>
                    <CloseIcon />
                  </div>

                  <div className="mfa-reset-picture">
                    <div className="mfa-reset-pop-up-qr-code">
                      <TrachRedIcon />
                    </div>
                  </div>

                  <div className="mfa-reset-popup-section">
                    <div className="mfa-reset-popup-title">
                      Confirm MFA Reset
                    </div>

                    <div className="mfa-reset-popup-paragraphe">
                      Are you sure you want to reset mfa code?
                    </div>
                  </div>

                  <div className="input-text-mfa">
                    <input
                      className="reset-mfa-text"
                      type="text"
                      placeholder="Enter RESET MFA"
                      value={resetText}
                      onChange={(e) => setResetText(e.target.value)}
                    />
                  </div>

                  <div className="popup-action">
                    <div
                      className={`popup-reset-button ${!canReset ? "disabled" : ""}`}
                      onClick={() => {
                        if (!canReset) return;
                        handleResetMfa();
                      }}
                    >
                      <ResetIcon />
                    </div>

                    <div
                      className="popup-cancel-button"
                      onClick={closeResetPopup}
                    >
                      <CancelIcon />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            className="signin-verification-action-bottom"
            onClick={handleSignin}
          >
            Sign In
          </div>

          <div className="terms-and-conditions">
            <div className="terms-and-conditions-text">
              By creating an account, you agree to Azalea’s{" "}
              <div className="terms-of-use">Terms of Use</div> and{" "}
              <div className="privacy-policy">Privacy Policy</div>.
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SignInVerification;
